module.exports = __webpack_public_path__ + "img/ico_share.4ec90766.svg";